/**/
$(document).ready(function() {
    //установка ширины input по длине значения
    $('input#copyPromo__input').attr('size', ($('input#copyPromo__input').val() || '').length - 2);

    //переворачивание карточки
    $('#signUp_flip input.lk-btn').on('click', function (e) {
        e.preventDefault();

        $('#signUp_flip').addClass('flip');
    });

    // копирование промокода
    $('#signUp_flip #copyPromo__btn').on('click', function () {

        $('#signUp_flip input#copyPromo__input').select();
        document.execCommand("copy");

        // для смены иконки
        $(this).addClass('copied');

        // показать текст
        $(this).closest('.copyPromoWrap').next('.promo__subtext').addClass('show');
    });
});


